module.exports = __webpack_public_path__ + "img/w3_logout_black.6752f69b.png";